import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/htx/screening-procedures/dentalScreening";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	dentalScreening: {
		id: "form.dental_screening",
		defaultMessage: "Fogászat"
	},
	result: {
		id: "form.dental_screening.result",
		defaultMessage: "Eltérés"
	}
});

const fields: { [key: string]: FieldData } = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: resultMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.result }] }]
};

export const node: LeafNode = {
	id: "dentalScreening",
	value: {
		title: messages.dentalScreening,
		validator,
		fieldset,
		isImportant: true
	}
};
